/*!

=========================================================
* Vue Argon Dashboard PRO - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

require("dotenv").config();

import { createApp } from "vue";
import store from "@/store";

import App from "./App.vue";
import router from "./router";
import ArgonDashboard from "./plugins/argon-dashboard";
import '@element-plus/theme-chalk/dist/index.css'
import {VueCsvImportPlugin} from "vue-csv-import";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

const options = { containerClassName: "ct-notification" };

const appInstance = createApp(App);
appInstance.use(store);
appInstance.use(router);
appInstance.use(VueCsvImportPlugin);
appInstance.use(Toast, options);
appInstance.use(ArgonDashboard);
appInstance.mount("#app");
